import { TableCellText } from '../../TableCellText'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TableTextCell({
  children,
  done,
  showTooltip,
  textCellProps,
  tooltip,
  unread,
  value,
  ...cellProps
}) {
  return value ? (
    <TableCellBase {...cellProps}>
      <TableCellText
        {...textCellProps}
        done={done}
        showTooltip={showTooltip}
        tooltip={tooltip}
        unread={unread}
        value={value}
      />
      {children}
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableTextCell
